export default "__VITE_ASSET__Cjtg0Swg__"